import { Input, Space } from 'antd';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';

import * as React from 'react';
import classNames from 'classnames';
import CommonButton from '../../Buttons/CommonButton';

const { TextArea } = Input;

interface InputFieldProps {
  type: string;
  hasLock?: boolean;
  locked?: boolean;
  disabled?: boolean;
  value?: any;
}

const InputField: React.FC<InputFieldProps> = React.forwardRef(({ ...props }, ref) => {
  const onKeyPress = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
    }
  };

  const [isLocked, setIsLocked] = React.useState(false);
  const toggleLock = () => {
    setIsLocked((lock) => !lock);
  };

  React.useEffect(() => {
    if (props.hasLock && props.value && isLocked === undefined) {
      setIsLocked(true);
    }
  }, [props.value, isLocked]);

  let Comp: any = Input;
  switch (props.type) {
    case 'textarea':
      Comp = TextArea;
      break;

    case 'password':
      Comp = Input.Password;
      break;

    default:
      Comp = Input;
      break;
  }
  return (
    <div className={classNames('flex-row', { hasLock: props.hasLock })}>
      <Comp
        {...props}
        onKeyPress={props.type === 'textarea' ? onKeyPress : null}
        disabled={props.disabled || isLocked}
      />
      {props.hasLock && (
        <span className={classNames('lockInput', { isLocked })}>
          <CommonButton
            type="link"
            tooltip={isLocked ? 'Sblocca' : 'Blocca'}
            icon={isLocked ? <LockOutlined /> : <UnlockOutlined />}
            onClick={toggleLock}
          />
        </span>
      )}
    </div>
  );
});

export default InputField;
